import React from "react";
import "./LastPitch.css";
import { Link } from "react-router-dom";
import { images } from "../../../assets";

function LastPitch() {
  return (
    <div className="lastpitch">
      <div className="outerdiv">
        <div className="text">  
            <div className="text1">Want to get healthy and help charities and win rewards?</div>
            <div className="text2">Come, join our 4M global community!</div>
        </div>
        <div className="playsotre" >
          <Link to="https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en" ><img  className="googleicon" src={images.playStore} alt="google-icon" />  </Link>
          <Link to="https://apps.apple.com/in/app/impact-fitness-charity/id1143265464" ><img className="appleicon" src={images.appleStore} alt="apple-icon" />  </Link>
        </div>
      </div>
    </div>
  );
}

export default LastPitch;
